export default __webpack_public_path__ + "static/media/EDUMani.6af7b109.png";